<template>
  <div>
    <TablePublic :colLists="historyColLists" :tableData="tableData" :paginationFlag="false">
      <template slot="modificationDesc" slot-scope="scope">
        <div style="white-space: normal; text-align: left">{{ scope.data.modificationDesc }}</div>
        <div slot="reference" @click="handleHistoryDetail(scope.data)" style="width: 150px">
          <span>“检查项"修改</span>
          <span class="view_button">&lt;详情&gt;</span>
        </div>
      </template>
      <template slot="reason" slot-scope="scope">
        <div style="white-space: normal">{{ scope.data.reason }}</div>
      </template>
    </TablePublic>

    <Mdialog
        title="检查项修改详情"
        :visible.sync="freshModifcationDialog"
        width="50%"
        :close-on-click-modal="false"
        :append-to-body="true"
        :destroy-on-close="true"
        @closes="freshModifcationDialog = false"
      >
        <ModifyComparesion>
          <template slot="after">
            <ReceiptTable :check-items="historyForm.currCheckItems" :bizNo="formData.pickingBatchBizNo"/>
          </template>
          <template slot="before">
            <ReceiptTable :check-items="historyForm.orignalCheckItems" :bizNo="formData.pickingBatchBizNo"/>
          </template>
        </ModifyComparesion>
      </Mdialog>
  </div>
</template>

<script>
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic.vue'
import ReceiptTable from './ReceiptTable.vue'
import ModifyComparesion from '@/components/ModifyComparesion.vue'

import { getAmdRecList } from '@/api/manage/amd-rec'
export default {
  name: 'HistoryRecord',
  components: {
    Mdialog,
    TablePublic,
    ReceiptTable,
    ModifyComparesion,
  },
  props: {
    formData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    const _this = this
    return {
      freshModifcationDialog: false,
      
      tableData: [],
      historyColLists: [
        {
          prop: 'modificationDesc',
          label: '修改内容',
          formSolt: true,
          isTrue: true,
        },
        {
          prop: 'reason',
          label: '修改原因',
          isTrue: true,
          formSolt: true,
        },
        {
          prop: 'createTime',
          label: '修改日期',
          isTrue: true,
          width: 150,
          formatter(row) {
            return row.createTime ? _this.parseTime(row.createTime, '{y}-{m}-{d}') : ''
          },
        },
        {
          prop: 'createBy',
          label: '修改人',
          isTrue: true,
          width: 150,
        },
      ],

      historyForm: {},
    }
  },
  mounted() {
    this.getHistoryList()
  },
  methods: {
    async getHistoryList() {
      const data = await getAmdRecList({ formId: this.$route.query.inspectionSheetId, formType: 'inspection_sheet' })
      if (data.code == 200 && data.flag) {
        this.tableData = data.data
      }
    },
    handleHistoryDetail(data) {
      const pickingBatchBizNo = this.formData.pickingBatchBizNo

      const currCheckItems = JSON.parse(data.currContent).items?.find(
        (item) => item.pickingBatchBizNo === pickingBatchBizNo
      )?.checkItems
      const orignalCheckItems = JSON.parse(data.orignalContent).items?.find(
        (item) => item.pickingBatchBizNo === pickingBatchBizNo
      )?.checkItems

      this.historyForm = {
        currCheckItems,
        orignalCheckItems,
      }
      this.freshModifcationDialog = true
    },
  },
}
</script>

<style scoped lang="less">

</style>
